import SweetScroll from 'sweet-scroll'
import {
  getViewport,
  watchAwaitSelector,
  equalHeights,
  replaceElement,
  throttle,
  debounce,
  available,
  notAvailable
} from './functions'

HTMLDocument.prototype.ready = function () {
  // Document load/ready promise, calls 'ready' method when completed
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  const scroller = new SweetScroll()
  const noStockButton = document.getElementById('BIS_trigger')
  const submitButton = document.querySelector('.ProductForm__AddToCart')

  throttle('resize', 'resize.optimized')
  window.viewportWidth = getViewport().width
  window.viewportHeight = getViewport().height
  window.mainBreakpoint = 1008

  if (viewportWidth >= mainBreakpoint) {
    document.documentElement.classList.add('is-desktop')
  } else {
    document.documentElement.classList.add('is-mobile')
  }

  console.log(viewportWidth)



  window.addEventListener('resize.optimized', function () {
    window.viewportWidth = getViewport().width
    window.viewportHeight = getViewport().height

    console.log(viewportWidth)

    if (viewportWidth >= mainBreakpoint) {
      document.documentElement.classList.add('is-desktop')
      document.documentElement.classList.remove('is-mobile')
    } else {
      document.documentElement.classList.remove('is-desktop')
      document.documentElement.classList.add('is-mobile')
    }

    equalHeights('.MegaMenu__PushImageWrapper', false)
    equalHeights('.Blog .ArticleItem__Title', true)
  })

  watchAwaitSelector(function () {
    equalHeights('.MegaMenu__PushImageWrapper', false)
  }, '.MegaMenu__PushImageWrapper')

  watchAwaitSelector(function () {
    equalHeights('.Blog .ArticleItem__Title', true)
  }, '.Blog .ArticleItem__Title')

  const replaceLinks = document.querySelectorAll(
    'a[href="/collections/all"], a[href="/collections"], a[href="/collections/"]'
  )
  for (const link of replaceLinks) {
    replaceElement(link, 'span', ['replaced-link'])
  }

  // For the book variant "back in stock" functionality
  watchAwaitSelector(function () {
    if (window.bookVariants) {
      const stockButton = document.getElementById('BIS_trigger')
      const submitButton = document.querySelector('.ProductForm__AddToCartButton')

      const options = document.querySelectorAll('.format-option-list .format-option')
      for (const option of options) {
        option.addEventListener('click', function () {
          const valueName = option.value

          if (window.bookVariants[valueName] && window.bookVariants[valueName].available === 'true') {
            stockButton.classList.remove('variant-out-of-stock')
            submitButton.classList.remove('variant-out-of-stock')
          } else {
            stockButton.classList.add('variant-out-of-stock')
            submitButton.classList.add('variant-out-of-stock')
          }
        })
      }
    }
  }, '.format-option-list .format-option')

  const allProductImageWrappers = document.querySelectorAll('[data-image-id-only]')

  const isQuinceQuarterlyPage = document.querySelector('.Product.Product--QuinceQuarterly')

  document.addEventListener('variant:changed', function (event) {
    // Gives you access to the variant details from theme
    const { variant } = event.detail
    noStockButton.dataset.variantId = variant.id

    if (!isQuinceQuarterlyPage) {
      if (variant.available === true) {
        console.log('is available')
        available(submitButton, noStockButton)
      } else {
        console.log('is not available')
        notAvailable(submitButton, noStockButton)
      }
    }

    if (variant.featured_image && variant.featured_image.id) {
      const currentVariantImageWrappers = document.querySelectorAll(
        `[data-image-id-only="${variant.featured_image.id}"]`
      )

      // Check for matching variant images to switch to,
      // otherwise we don't change the currently visible image(s)
      if (currentVariantImageWrappers.length > 0) {
        for (const wrapper of allProductImageWrappers) {
          wrapper.classList.remove('is-active')
        }

        for (const wrapper of currentVariantImageWrappers) {
          wrapper.classList.add('is-active')
        }
      }
    }
  })

  const currentlySelectedPopoverValue = document.querySelector('.Popover__Value.is-selected')
  if (currentlySelectedPopoverValue && currentlySelectedPopoverValue.dataset.variantImageId) {
    const currentVariantImageWrappers = document.querySelectorAll(
      `[data-image-id-only="${currentlySelectedPopoverValue.dataset.variantImageId}"]`
    )
    if (currentVariantImageWrappers.length > 0) {
      for (const wrapper of allProductImageWrappers) {
        wrapper.classList.remove('is-active')
      }

      for (const wrapper of currentVariantImageWrappers) {
        wrapper.classList.add('is-active')
      }
    }
  }




  var _second = 1000;
  var _minute = _second * 60;
  var _hour = _minute * 60;
  var _day = _hour * 24;
  var timer;


  function showRemaining() {
    const announcementBar = document.getElementById('announcement-bar');
    const test2 = announcementBar.getAttribute('data-countdown-start');
    const test = announcementBar.getAttribute('data-countdown-end');
    const end = new Date(test);
    const start = new Date(test2);


    var now = new Date();
    var offset;
    var est = new Date(new Date().getTime() + offset * 3600 * 1000);
    var distance = end - now;
    var beginning = now - start;

    // console.log('now is ' + now);
    // console.log('start is ' + start);
    // console.log('end is ' + end);
    // console.log('begin is ' + beginning)




    Date.prototype.stdTimezoneOffset = function () {
      var jan = new Date(this.getFullYear(), 0, 1);
      var jul = new Date(this.getFullYear(), 6, 1);
      return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    Date.prototype.isDstObserved = function () {
      return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }
    var dst;
    if (now.isDstObserved()) {
      dst = 1;
      distance = distance - 3600000;
      beginning = beginning + 3600000;
      // console.log('distance is now ' + distance);


    } else {
      dst = 0;
    }
    if (beginning >= 0) {
      announcementBar.style.display = 'block';

      // console.log('start');
    }
    if (distance < 0) {

      clearInterval(timer);
      document.getElementById('countdown').innerHTML = '';
      announcementBar.style.display = 'none';


      return;
    }


    var daysCalc = Math.floor(distance / _day);
    var hoursCalc = Math.floor(((distance % _day) / _hour) - dst);
    var minutesCalc = Math.floor((distance % _hour) / _minute);
    var secondsCalc = Math.floor((distance % _minute) / _second);
    var days = ("0" + daysCalc).slice(-2)
    var hours = ("0" + hoursCalc).slice(-2)
    if (hours < 0) {
      hours = '00';
    }
    var minutes = ("0" + minutesCalc).slice(-2)
    var seconds = ("0" + secondsCalc).slice(-2)
    // console.log(("0" + seconds).slice(-2));
    document.getElementById('countdown').innerHTML = days + ':';
    document.getElementById('countdown').innerHTML += hours + ':';
    document.getElementById('countdown').innerHTML += minutes + ':';
    document.getElementById('countdown').innerHTML += seconds;
  }

  timer = setInterval(showRemaining, 1000);




})




